module.exports = __webpack_public_path__ + "media/dinosaur.6fb69520.mp3";